/**
 * Simple event bus for application-wide events
 * Used to trigger refreshes across components without prop drilling
 */

class EventBus {
  constructor() {
    this.listeners = {};
  }

  /**
   * Subscribe to an event
   * @param {string} event - Event name
   * @param {Function} callback - Function to call when event is triggered
   * @returns {Function} Unsubscribe function
   */
  subscribe(event, callback) {
    if (!this.listeners[event]) {
      this.listeners[event] = [];
    }
    this.listeners[event].push(callback);

    // Return unsubscribe function
    return () => {
      this.listeners[event] = this.listeners[event].filter(cb => cb !== callback);
    };
  }

  /**
   * Publish an event
   * @param {string} event - Event name
   * @param {any} data - Data to pass to subscribers
   */
  publish(event, data) {
    if (this.listeners[event]) {
      this.listeners[event].forEach(callback => {
        callback(data);
      });
    }
  }
}

// Export a singleton instance
export const eventBus = new EventBus();

// Define event constants
export const EVENTS = {
  BATCH_CONFIG_CHANGED: 'BATCH_CONFIG_CHANGED',
  BATCH_EXECUTION_STARTED: 'BATCH_EXECUTION_STARTED',
  BATCH_EXECUTION_COMPLETED: 'BATCH_EXECUTION_COMPLETED',
  SCHEDULER_STATUS_REFRESH: 'SCHEDULER_STATUS_REFRESH',
  BATCH_TASK_COMPLETED: 'BATCH_TASK_COMPLETED'
};
